const rightTrim = (str: string, character: string = '/') => {
    return str.endsWith(character) ? str.slice(0, -1) : str;
};

export { rightTrim };
